/**
 * Directive: feature
 */
angular.module('acme.common.directive.feature', [
  'acme.common.service.featureToggle'
])
.directive('feature', ['FeatureToggleService', function(FeatureToggleService) {

    return {
      restrict: 'A',

      link: function($scope, $element, $attrs) {
        // Modified after controller runs
        var test = $attrs.feature;

        // Modified after controller runs
        if (test.match(/^\[/)) {
          test = $scope.$eval(test);
        }

        if (!FeatureToggleService.check(test)) {
          $element.remove();
        }
      }

    };

}]);